/**
* Created by bieao on 2020/4/1.
*/
<template>
  <el-result icon="warning" title="警告提示" subTitle="数据错误，请重新打开"/>
</template>

<script>

export default {
  name: 'noFoundPage'
}
</script>



// WEBPACK FOOTER //
// src/pages/404.vue